<template src="./StoreCreateOrUpdateComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, onMounted, watchEffect, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import {useProductStore} from "@/stores/product.js";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useRoute, useRouter} from "vue-router";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {useStore} from "@/stores/store.js";
export default {
  name: 'StoreCreateOrUpdateComponent',
  components: {
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const errors = ref(true)
    const mode = ref('create')
    const store_id = ref(null)
    const labelButtonSetting = ref('Tạo cửa hàng')
    const usingWarehouse = ref(null)
    const storeDetail = ref({})
    const dataStore = ref({
      store_name: {
        id: 'store_name',
        label: 'Tên cửa hàng',
        placeholder: 'Tên cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      store_code: {
        id: 'store_code',
        label: 'Mã cửa hàng',
        placeholder: 'Mã cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      store_phone: {
        id: 'store_phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      store_addr: {
        id: 'store_addr',
        label: 'Địa chỉ cửa hàng',
        placeholder: 'Địa chỉ cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
    })
    const router = useRouter()
    const route = useRoute()
    const storeCompStore = useStore()
    const accountStore = useAccountStore()

    onMounted(() => {
      mode.value = route.params.mode;
      if(mode.value === 'detail') {
        labelButtonSetting.value = 'Cập nhập cửa hàng';
        store_id.value =  route.params.id;
        getStoreDetail();
      }
    });

    watch(() => storeCompStore.store, (newStore) => {
      storeDetail.value = newStore
      dataStore.value.store_name.value = newStore.name;
      dataStore.value.store_code.value = newStore.code;
      dataStore.value.store_addr.value = newStore.address;
      dataStore.value.store_phone.value = newStore.phone;
    });

    async function createOrUpdateStore() {
      for (const item in dataStore.value) {
        validateForm(dataStore.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          name: dataStore.value.store_name.value,
          code: dataStore.value.store_code.value,
          phone: dataStore.value.store_phone.value,
          address: dataStore.value.store_addr.value,
        }
        let url = AppConstant.URL_API_LOCAL + 'api/v1/stores/create-store';
        if(mode.value === 'detail') {
          params.id = store_id.value;
          url = AppConstant.URL_API_LOCAL + 'api/v1/stores/update-store';
        }
        const store = await storeCompStore.createOrUpdateStore(url, params);
        await CommonService.showAlertPopup({
          title: store?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });

        await router.push('/stores')
      }
    }

    function getStoreDetail() {
      const params = {
        company_id: accountStore.account.company.id,
        store_id: store_id.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/detail';
      storeCompStore.getStoreDetail(url, params);
    }
    function onChange(value, name) {
      dataStore.value[name].value = value
    }
    function validateForm(value, name) {
      if(name === 'store_name') {
        dataStore.value.store_name.isError = false;
        dataStore.value.store_name.error = ''
        errors.value = false
        if(!value) {
          dataStore.value.store_name.isError = true;
          dataStore.value.store_name.error = ErrorText.REQUIRED(dataStore.value.store_name.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_TEXT) {
          dataStore.value.store_name.isError = true;
          dataStore.value.store_name.error = ErrorText.MAX_LENGTH(dataStore.value.store_name.label, AppConstant.MAX_LENGTH_TEXT);
          errors.value = true
        }
      }
      if(name === 'store_code') {
        dataStore.value.store_code.isError = false;
        dataStore.value.store_code.error = ''
        errors.value = false
        if(!value) {
          dataStore.value.store_code.isError = true;
          dataStore.value.store_code.error = ErrorText.REQUIRED(dataStore.value.store_code.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_SKU_CODE) {
          dataStore.value.store_code.isError = true;
          dataStore.value.store_code.error = ErrorText.MAX_LENGTH(dataStore.value.store_code.label, AppConstant.MAX_LENGTH_SKU_CODE);
          errors.value = true
        }
      }
      if(name === 'store_phone') {
        dataStore.value.store_phone.isError = false;
        dataStore.value.store_phone.error = ''
        errors.value = false
        if(!Number(value)) {
          dataStore.value.store_phone.isError = true;
          dataStore.value.store_phone.error = ErrorText.REQUIRED(dataStore.value.store_phone.label);
          errors.value = true
        }
        if(!errors.value && !CommonService.validateDecimal(value)) {
          dataStore.value.store_phone.isError = true;
          dataStore.value.store_phone.error = ErrorMessageConstant.ERROR_NUMBER_INVALID;
          errors.value = true
        }
      }
      if(name === 'store_addr') {
        dataStore.value.store_addr.isError = false;
        dataStore.value.store_addr.error = ''
        errors.value = false
        if(!value) {
          dataStore.value.store_addr.isError = true;
          dataStore.value.store_addr.error = ErrorText.REQUIRED(dataStore.value.store_addr.label);
          errors.value = true
        }
        if(!errors.value && !CommonService.validateDecimal(value)) {
          dataStore.value.store_addr.isError = true;
          dataStore.value.store_addr.error = ErrorMessageConstant.ERROR_NUMBER_INVALID;
          errors.value = true
        }
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    return {
      createOrUpdateStore,
      dataStore,
      mode,
      usingWarehouse,
      labelButtonSetting,
      CommonService,
      errors,
      onChange,
      validateForm,
      checkSubmitActive
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
